export default __webpack_public_path__ + "static/media/FUD_120_StompySlosh.27bdc145.mp3";